// extracted by mini-css-extract-plugin
module.exports = {"leadership-cards-list":"LeadershipList_leadership-cards-list__uIVUM","leadership-owners-list":"LeadershipList_leadership-owners-list__3W1wh"};